module.exports = __webpack_public_path__ + "static/google-173000fc28bd3516ea35213639d25149.webp";